import { gql } from "@/gql/__generated__";
import { Get_User_RoleQuery } from "@/gql/__generated__/graphql";
import { useMutation } from "@apollo/client";
import { GET_USER_ROLE } from "../user/useUserRole";

const ORGANIZATION_RENAME = gql(`
  mutation ORGANIZATION_RENAME($id: ID!, $name: String!) {
    organizationRename(organizationId: $id name: $name ) {
        __typename
        ... on Organization {
            id
            name
            slug
        }
        ... on OrganizationNotFound {
            id
        }
        ... on OrganizationRenameFailure {
            result
        }
    }
  }
`);

export const useOrganizationRename = () => {
  const mutation = useMutation(ORGANIZATION_RENAME, {
    update(cache, { data }) {
      if (!data || data.organizationRename.__typename !== "Organization")
        return;

      const renamedOrganization = data.organizationRename;

      cache.updateQuery({ query: GET_USER_ROLE }, (cacheData) => {
        if (!cacheData || cacheData.me.memberships.length < 1) return undefined;

        const updatedMemberships: Get_User_RoleQuery["me"]["memberships"] =
          cacheData.me.memberships.map((membership) =>
            membership.organization.id !== renamedOrganization.id
              ? membership
              : {
                  ...membership,
                  organization: {
                    __typename: "Organization",
                    id: renamedOrganization.id,
                    slug: renamedOrganization.slug
                  }
                }
          );

        const updatedQuery: Get_User_RoleQuery = {
          ...cacheData,
          me: {
            ...cacheData.me,
            memberships: updatedMemberships
          }
        };

        return updatedQuery;
      });
    }
  });
  return mutation;
};
